<template>
    <div class="checkbox">
        <label>
            <input
                v-bind:name="name"
                v-bind:value="value"
                v-bind:disabled="disabled"
                v-bind:checked="checked"
                :tabindex="tabindex"
                @change="onChange($event)"
                type="checkbox"
                v-bind="$attrs"
            />
            <i></i>
            <span><slot></slot></span>
        </label>
    </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { CheckboxUpdatedEvent } from "@/shared/models/checkbox";

export default class BaseCheckbox extends Vue {
    @Prop() name = "";
    @Prop() checked = false;
    @Prop() disabled = false;
    @Prop() tabindex?: number;
    @Prop() value: string | number = "";

    @Emit("checkboxUpdated")
    onChange({ target }: { target: HTMLInputElement }): CheckboxUpdatedEvent {
        return { value: this.value, checked: target.checked };
    }
}
</script>
